import ApiClient from './api-client'
import interval from 'interval-promise'
import store from '../store'

export default class GeometricWebserviceClient {
  constructor (token) {
    this.client = new ApiClient(token, process.env.VUE_APP_WEBSERVICE_URL)
  }

  async getNewCustomersCount () {
    const data = await this.client.get('newCustomersCount')
    return data.customerCount
  }

  async cacheCustomers () {
    const userParams = store.state.user.params
    let totalCustomersUpdated = userParams.totalCustomersUpdated || 0
    let totalCustomersToGeocode = userParams.totalCustomersToGeocode || 0
    let remainingCredits = userParams.creditsRemaining
    let nextPageKey
    await (async () => {
      do {
        const data = await this.client.get('cacheCustomers')
        // { totalCustomersUpdated, totalCustomersToGeocode, remainingCredits } = data
        totalCustomersUpdated += data.totalCustomersUpdated
        totalCustomersToGeocode += data.totalCustomersToGeocode
        remainingCredits = data.remainingCredits
        nextPageKey = data.nextPageKey
        console.log(nextPageKey)
      } while (nextPageKey !== null)
    })()
    return { totalCustomersUpdated, totalCustomersToGeocode, remainingCredits }
  }

  async startGeocoder () {
    const response = await this.client.get('startGeocoder')
    return response
  }

  async importCustomers (disableGeocoder) {
    await this.client.get('importCustomers', { disableGeocoder })
    let numSeconds = 0
    await interval(async (iteration, stop) => {
      // maybe i can use this iteration value to give importCustomers a buffer?
      if (numSeconds >= 30) {
        console.log('interval has started', iteration)
        const importFinished = await this.client.get('checkImport')
        console.log(importFinished)
        if (importFinished) {
          console.log('geocoding complete')
          stop()
        }
      }
      numSeconds += 10
      if (numSeconds === 300) {
        stop()
        throw new Error('Please try again')
      }
    }, 10000)
    return true
  }

  async checkHereStatus (hereJobId) {
    const jobId = hereJobId || store.state.user.params.hereJobId
    let numSeconds = 0
    await interval(async (iteration, stop) => {
      const hereResponse = await this.client.get('checkHereStatus', { jobId })
      console.log('here call status ===>', hereResponse.Response.Status)
      if (hereResponse.Response.Status === 'completed') {
        console.log('geocoding complete')
        stop()
      }
      numSeconds += 5
      if (numSeconds === 120) {
        stop()
        throw new Error('Please try again')
      }
    }, 5000)
  }
}
